import Axios from "axios";
import { firebaseAuth } from "../config/firebase";

const BASE_URL = `${import.meta.env.VITE_BASE_URL_API_BACKEND}/chat-messages`;

async function getAuthHeaders() {
  const user = firebaseAuth.currentUser;
  const headers = { "Content-Type": "application/json" };
  if (user) {
    try {
      headers["Authorization"] = `Bearer ${await user.getIdToken()}`;
    } catch {}
  }
  const tenantId = localStorage.getItem("tenant_id");
  if (tenantId) headers["X-Tenant-Id"] = tenantId;
  return headers;
}

export default class chatMessageService {
  static get = async () => {
    try {
      const { data } = await Axios.get(BASE_URL);
      return data;
    } catch {
      return false;
    }
  };

  static getById = async (id) => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/${id}`);
      return data;
    } catch {
      return false;
    }
  };

  static post = async (payload) => {
    try {
      const { data } = await Axios.post(BASE_URL, payload);
      return data;
    } catch {
      return false;
    }
  };

  static postAsk = async (payload) => {
    const headers = await getAuthHeaders();
    const resp = await fetch(`${BASE_URL}/ask`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
    const data = await resp.json();
    if (!data.success) throw new Error(data.error?.message || "Erro desconhecido");
    return data.data?.message || "";
  };

  static postStream = async (payload, onToken, onDone, onError) => {
    const headers = await getAuthHeaders();
    let reader;
    try {
      const resp = await fetch(`${BASE_URL}/stream`, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        onError?.(`Erro ${resp.status}`);
        return;
      }

      reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop() ?? "";

        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          const raw = line.slice(6).trim();
          if (raw === "[DONE]") { onDone?.(); return; }
          try {
            const parsed = JSON.parse(raw);
            if (parsed.error) { onError?.(parsed.error); return; }
            if (parsed.token) onToken?.(parsed.token);
          } catch {}
        }
      }
      onDone?.();
    } catch (err) {
      onError?.(err.message);
    }
  };

  static put = async (id, payload) => {
    try {
      const { data } = await Axios.put(`${BASE_URL}/${id}`, payload);
      return data;
    } catch {
      return false;
    }
  };

  static delete = async (id) => {
    try {
      await Axios.delete(`${BASE_URL}/${id}`);
      return true;
    } catch {
      return false;
    }
  };
}
